import WebFont from 'webfontloader'

WebFont.load({
  google: {
    families: ['Press Start 2P']
  }
});